import { render, staticRenderFns } from "./ButtonSearch.vue?vue&type=template&id=1be24092&scoped=true&"
import script from "./ButtonSearch.vue?vue&type=script&lang=ts&"
export * from "./ButtonSearch.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonSearch.vue?vue&type=style&index=0&id=1be24092&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be24092",
  null
  
)

export default component.exports